import BookingForm from '../components/BookingForm';

const BookingPage = () => {
  return (
    <section>
      <BookingForm />
    </section>
  );
};
export default BookingPage;
